module.exports = __webpack_public_path__ + "assets/images/bellingen_property_posf9a85931.png";